export const getFullNameOrEmail = ({ firstName, lastName, emailAddress }) => {
  const fullName = [firstName, lastName].join(' ').trim();
  return fullName || emailAddress;
};
